import { createSlice } from '@reduxjs/toolkit';
import type { QuoteApprovalData, QuoteApprovalState } from 'src/types/quote-approval';
import reducers from 'src/redux/quote-approval/reducers';
import extraReducers from './extra-reducers';

export const initialState: QuoteApprovalState = {
  isLoading: true,
  data: {} as QuoteApprovalData,
  approvedTasks: [],
  rejectedTasks: [],
  isMakeReady: false,
};

const quoteApproval = createSlice({
  name: 'quoteApproval',
  initialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const {
  setQuoteLoading,
  updateTaskStatus,
} = quoteApproval.actions;

export default quoteApproval.reducer;
